<header>
  <figure>
    <img src="/images/cone.png" width="113.185">
  </figure>
</header>

<section>
  <aside>
    <h1>{{'general.singular.oops' | transloco }}</h1>
    <h4 style="display: block;">{{'general.messages.error404' | transloco}}</h4>
    <button style="display: block;" [routerLink]="['/Home']"> {{'general.singular.goHome' | transloco}}</button>
  </aside>

  <figure>
    <svg xmlns="http://www.w3.org/2000/svg" width="420" viewBox="0 0 608.905 702.78">
      <g transform="translate(-345.784 -630.651)">
        <path d="M389.313,826.63" transform="translate(71.144 320.311)" fill="#8bc541" />
        <path
          d="M480.751,630.651l-22.582,31.083c45.491,34.139,78.366,85.85,88.24,143.815l37.812-5.988C573.014,732.073,535.039,670.133,480.751,630.651Z"
          transform="translate(183.684)" fill="#29afd4" />
        <path d="M422.523,902.682a270.381,270.381,0,0,0,34.969,2.687V867.144a229.383,229.383,0,0,1-28.981-2.263Z"
          transform="translate(125.423 382.829)" fill="#29afd4" />
        <path
          d="M492.087,898.375,480.235,861.9a226.864,226.864,0,0,1-28.27,6.781l5.988,37.812A265.533,265.533,0,0,0,492.087,898.375Z"
          transform="translate(173.544 377.963)" fill="#29afd4" />
        <path
          d="M509.45,891.1,492,856.86a227.136,227.136,0,0,1-26.837,11.165l11.855,36.487A263.417,263.417,0,0,0,509.45,891.1Z"
          transform="translate(195.123 369.719)" fill="#29afd4" />
        <path d="M467.377,864.881a229.383,229.383,0,0,1-28.981,2.263V905.37a270.383,270.383,0,0,0,34.969-2.687Z"
          transform="translate(151.366 382.829)" fill="#29afd4" />
        <path
          d="M549.36,853.564l-31.081-22.582a230.752,230.752,0,0,1-18.894,22.074l27.15,27.15A270.485,270.485,0,0,0,549.36,853.564Z"
          transform="translate(251.048 327.424)" fill="#29afd4" />
        <path
          d="M578.55,689.931,544.3,672.483a229.051,229.051,0,0,1-15.216,24.756l31.091,22.59A265.426,265.426,0,0,0,578.55,689.931Z"
          transform="translate(299.591 68.371)" fill="#29afd4" />
        <path d="M457.556,690H419.328a229.9,229.9,0,0,1-2.26,28.981l37.8,5.988A271.314,271.314,0,0,0,457.556,690Z"
          transform="translate(116.508 97.001)" fill="#29afd4" />
        <path
          d="M565.683,766.769l-37.812-5.991a226.537,226.537,0,0,1-6.781,28.273l36.473,11.85A265.383,265.383,0,0,0,565.683,766.769Z"
          transform="translate(286.523 212.681)" fill="#29afd4" />
        <path
          d="M399.7,750.836l-36.487-11.855a227.814,227.814,0,0,1-11.165,26.839l34.234,17.442A263.249,263.249,0,0,0,399.7,750.836Z"
          transform="translate(10.236 177.056)" fill="#29afd4" />
        <path
          d="M538.392,868.348,511.245,841.2a230.483,230.483,0,0,1-22.076,18.894l22.585,31.083A269.839,269.839,0,0,0,538.392,868.348Z"
          transform="translate(234.349 344.121)" fill="#29afd4" />
        <path
          d="M525.015,880.989,502.427,849.9a229.273,229.273,0,0,1-24.758,15.217l17.45,34.245A264.742,264.742,0,0,0,525.015,880.989Z"
          transform="translate(215.555 358.344)" fill="#29afd4" />
        <path
          d="M513.869,775.726l-37.8,5.988a229.922,229.922,0,0,1,2.26,28.981h38.228A271.314,271.314,0,0,0,513.869,775.726Z"
          transform="translate(212.938 237.113)" fill="#29afd4" />
        <path
          d="M588.744,911.208l5.983,37.77a308.351,308.351,0,0,1-45.525,3.385c-66.184,0-130.053-21.441-180.655-57.62,7.095-9.676,22.477-30.938,22.477-30.938C395.612,865.558,468.786,927.712,588.744,911.208Z"
          transform="translate(37.203 381.069)" fill="#28629b" />
        <path
          d="M501.643,914.6l-11.821-36.376a271.823,271.823,0,0,1-35.177,8.369l5.98,37.762A310.07,310.07,0,0,0,501.643,914.6Z"
          transform="translate(177.924 404.632)" fill="#28629b" />
        <path
          d="M521.26,906.26l-17.366-34.087A270.387,270.387,0,0,1,470.471,886l11.821,36.381A307.954,307.954,0,0,0,521.26,906.26Z"
          transform="translate(203.79 394.747)" fill="#28629b" />
        <path
          d="M538.762,894.743,516.285,863.8a271.752,271.752,0,0,1-30.812,18.936l17.366,34.081A309.857,309.857,0,0,0,538.762,894.743Z"
          transform="translate(228.31 381.069)" fill="#28629b" />
        <path
          d="M605.539,726.441l-37.762-5.983a272.758,272.758,0,0,1-8.37,35.18l36.373,11.818A310.092,310.092,0,0,0,605.539,726.441Z"
          transform="translate(349.15 146.782)" fill="#28629b" />
        <path
          d="M553.762,880.379l-27.034-27.037a277.328,277.328,0,0,1-27.458,23.525l22.482,30.944A315.4,315.4,0,0,0,553.762,880.379Z"
          transform="translate(250.858 363.969)" fill="#28629b" />
        <path
          d="M580.979,780.209H542.754a277.949,277.949,0,0,1-2.769,36.042l37.77,5.983A316.549,316.549,0,0,0,580.979,780.209Z"
          transform="translate(317.405 244.44)" fill="#28629b" />
        <path
          d="M530.755,750.048l-37.77,5.983a277.991,277.991,0,0,1,2.769,36.042h38.225A316.569,316.569,0,0,0,530.755,750.048Z"
          transform="translate(240.587 195.144)" fill="#28629b" />
        <path
          d="M566,863.564l-30.944-22.482a276.713,276.713,0,0,1-23.525,27.458l27.037,27.037A315.823,315.823,0,0,0,566,863.564Z"
          transform="translate(270.896 343.931)" fill="#28629b" />
        <path
          d="M580.564,824.106l-36.379-11.821a270.188,270.188,0,0,1-13.825,33.42l34.084,17.369A307.881,307.881,0,0,0,580.564,824.106Z"
          transform="translate(301.674 296.865)" fill="#28629b" />
        <path
          d="M575.006,844.651l-34.081-17.364A271.577,271.577,0,0,1,521.991,858.1l30.938,22.477A309.76,309.76,0,0,0,575.006,844.651Z"
          transform="translate(287.995 321.385)" fill="#28629b" />
        <path d="M562.539,770.537a310.118,310.118,0,0,0-9.758-41.015L516.408,741.34a272.738,272.738,0,0,1,8.37,35.18Z"
          transform="translate(278.87 161.596)" fill="#28629b" />
        <path d="M453.36,738.625a270.225,270.225,0,0,1,13.825,33.42l36.379-11.821a307.9,307.9,0,0,0-16.12-38.968Z"
          transform="translate(175.824 148.086)" fill="#28629b" />
        <path
          d="M384.528,751.363l36.386,11.823c8.754-27.108,7.582-54.817,7.582-54.817s-.6-27.664-7.582-47.967l-36.386,11.823a144.106,144.106,0,0,1,5.7,36.144S391.638,727.519,384.528,751.363Z"
          transform="translate(63.324 48.625)" fill="#28629b" />
        <path d="M443.92,832.814a138.152,138.152,0,0,1-14.508-3.472l-11.823,36.387a175.754,175.754,0,0,0,20.343,4.892Z"
          transform="translate(117.359 324.743)" fill="#28629b" />
        <path d="M376.928,791.076a137.23,137.23,0,0,1-13.788-5.7l-17.356,34.063a175.751,175.751,0,0,0,19.321,8.027Z"
          transform="translate(0 252.878)" fill="#28629b" />
        <path d="M427.879,868.861a177.322,177.322,0,0,0,20.859,1.631v-38.27a138.973,138.973,0,0,1-14.871-1.156Z"
          transform="translate(134.177 327.559)" fill="#28629b" />
        <path d="M408.876,796.05a138.99,138.99,0,0,1-12.693-7.835l-22.474,30.936a177.016,177.016,0,0,0,17.811,10.957Z"
          transform="translate(45.641 257.525)" fill="#28629b" />
        <path
          d="M472.94,865.729l-11.823-36.387a137.989,137.989,0,0,1-14.508,3.472l5.988,37.807A175.748,175.748,0,0,0,472.94,865.729Z"
          transform="translate(164.79 324.743)" fill="#28629b" />
        <path
          d="M447.729,819.435l-17.355-34.063a138.068,138.068,0,0,1-13.786,5.7l11.823,36.384A175.435,175.435,0,0,0,447.729,819.435Z"
          transform="translate(115.723 252.878)" fill="#28629b" />
        <path d="M453.267,831.065a138.973,138.973,0,0,1-14.871,1.156v38.27a177.322,177.322,0,0,0,20.859-1.631Z"
          transform="translate(151.366 327.559)" fill="#28629b" />
        <path
          d="M522.292,821.3l-34.055-17.353a139.125,139.125,0,0,1-7.835,12.69l30.933,22.477A177.337,177.337,0,0,0,522.292,821.3Z"
          transform="translate(220.022 283.241)" fill="#28629b" />
        <path
          d="M485.646,802.224,449.263,790.4a138.642,138.642,0,0,1-5.7,13.786l34.06,17.355A175.825,175.825,0,0,0,485.646,802.224Z"
          transform="translate(159.805 261.098)" fill="#28629b" />
        <path
          d="M419.825,742.344l-30.939-22.477a139.3,139.3,0,0,1-9.7,11.323l27.045,27.045A177.981,177.981,0,0,0,419.825,742.344Z"
          transform="translate(54.598 145.816)" fill="#28629b" />
        <path
          d="M497.3,853.148l-22.474-30.933a139.227,139.227,0,0,1-12.69,7.835l17.353,34.058A176.559,176.559,0,0,0,497.3,853.148Z"
          transform="translate(190.167 313.095)" fill="#28629b" />
        <path
          d="M507.423,844.05,480.378,817a139.953,139.953,0,0,1-11.325,9.7l22.477,30.936A178.072,178.072,0,0,0,507.423,844.05Z"
          transform="translate(201.473 304.575)" fill="#28629b" />
        <path d="M426.2,848.26c-1.085-.221-1.718-.343-1.718-.343.59.121,1.141.229,1.71.337Z"
          transform="translate(128.619 355.104)" fill="#1189ca" />
        <path
          d="M405.5,829.106l-27.019,27.019c64.151,64.967,150.991,62.644,150.991,62.644,81.4.827,131.044-40.423,131.044-40.423l-22.466-30.92s-44.224,35.156-108.577,32.885C489.275,879.3,448.231,868.051,405.5,829.106Zm97.781,50.281c-.274-.058-.574-.119-.851-.169C502.7,879.263,502.984,879.321,503.282,879.387Zm3.293.646-.029-.005Zm27.013,5.327c.487.1.8.163.906.179C534.408,885.522,534.115,885.464,533.588,885.359Z"
          transform="translate(53.442 324.358)" fill="#1189ca" />
        <path d="M483.8,741.184a182.544,182.544,0,0,1,8.441,20.311l36.368-11.818a220.515,220.515,0,0,0-10.754-25.846Z"
          transform="translate(225.582 152.295)" fill="#1189ca" />
        <path d="M424.113,686.475a185.385,185.385,0,0,1,16.707,14.289l27.019-27.019a223.576,223.576,0,0,0-21.26-18.193Z"
          transform="translate(128.022 40.698)" fill="#1189ca" />
        <path d="M472.712,788.34a220.04,220.04,0,0,0-6.531-27.227l-36.368,11.818a182.542,182.542,0,0,1,5.142,21.389Z"
          transform="translate(137.338 213.229)" fill="#1189ca" />
        <path d="M451.292,712.316a184.548,184.548,0,0,1,14.289,16.7l30.925-22.466a224.329,224.329,0,0,0-18.2-21.26Z"
          transform="translate(172.444 89.311)" fill="#1189ca" />
        <path
          d="M512.246,724.933a183.792,183.792,0,0,1,11.521,18.728l34.058-17.353a222.488,222.488,0,0,0-14.655-23.842Z"
          transform="translate(272.068 117.377)" fill="#1189ca" />
        <path
          d="M550.107,786H511.881a184.448,184.448,0,0,1-1.715,21.929l37.762,5.983A222.063,222.063,0,0,0,550.107,786Z"
          transform="translate(268.668 253.905)" fill="#1189ca" />
        <path
          d="M435.712,761.082l-37.756-5.98a182.513,182.513,0,0,1-5.142,21.389l36.368,11.818A220,220,0,0,0,435.712,761.082Z"
          transform="translate(76.865 203.404)" fill="#1189ca" />
        <path
          d="M464.928,725.405l-37.762,5.983a184.476,184.476,0,0,1,1.715,21.929h38.225A222.036,222.036,0,0,0,464.928,725.405Z"
          transform="translate(133.012 154.867)" fill="#1189ca" />
        <path
          d="M547.613,655.51l-36.368-11.818A182.592,182.592,0,0,1,502.8,664l34.055,17.353A220.7,220.7,0,0,0,547.613,655.51Z"
          transform="translate(256.636 21.314)" fill="#1189ca" />
        <path
          d="M522.839,856.125,495.82,829.106A185.344,185.344,0,0,1,479.113,843.4l22.466,30.923A223.6,223.6,0,0,0,522.839,856.125Z"
          transform="translate(217.915 324.358)" fill="#1189ca" />
        <path
          d="M539.824,829.069l-34.058-17.353a183.807,183.807,0,0,1-11.52,18.728l30.923,22.467A222.535,222.535,0,0,0,539.824,829.069Z"
          transform="translate(242.648 295.935)" fill="#1189ca" />
        <path
          d="M501.506,770.4l-30.925-22.469a184.617,184.617,0,0,1-14.289,16.707l27.019,27.019A223.975,223.975,0,0,0,501.506,770.4Z"
          transform="translate(180.616 191.676)" fill="#1189ca" />
      </g>
    </svg>
  </figure>
</section>